"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prefixList = exports.attributeIncludeParameters = void 0;
function attributeIncludeParameters(type, attributeInclude) {
    if (!attributeInclude) {
        return [];
    }
    const parameterValues = [];
    if (attributeInclude === 'all') {
        parameterValues.push(type);
    }
    else {
        if (attributeInclude.withKey) {
            parameterValues.push(`${type}:key(${attributeInclude.withKey.join('|')})`);
        }
        if (attributeInclude.ofType) {
            parameterValues.push(`${type}:type(${attributeInclude.ofType.join('|')})`);
        }
    }
    return parameterValues;
}
exports.attributeIncludeParameters = attributeIncludeParameters;
function prefixList(prefix) {
    return list => list.map(value => `${prefix}${value}`);
}
exports.prefixList = prefixList;
